export async function getDeviceFcmToken(): Promise<string | null> {
    return null;
}
